// extracted by mini-css-extract-plugin
export default {"infoIcon":"NastavnoOsobljeList_infoIcon__qj3uK"};